import React from "react";
import styled from "styled-components";
import goodStand from '../../assets/newSvg/good-stand1.png';
import Share from "../../assets/newSvg/share";
import Like from "../../assets/newSvg/act-like";
import dLike from "../../assets/newSvg/dis-like.svg";
import { createRef } from "react";
import { PostData } from "../Functions/SendingData";
import { insertError } from "../StakcableError";
import { changePrice, checkPriceCut, formatPrice } from "../Functions/Price";
import truck from "../../assets/newSvg/truck-time.svg"
import { insertGood } from "../Menu/UniBasket";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import { CarouselProvider, Dot, Slide, Slider } from "pure-react-carousel";
import 'pure-react-carousel/dist/react-carousel.es.css';

import { Garanty } from "../Scomp/Garanty";
import GoodPicManager from "./GoodPicManager";



const Styles = styled.div` 
  padding: 1rem 0 0;
  .shoptop-container {
    display: flex;
    flex-direction: column;
    margin: 0 calc(var(--padding) - 1rem);
    position: relative;

    .title {
      font-weight: 700;
      font-size: 12px;
      margin: 0 1rem;
    }
    .scroll-container {
      display: block;
      overflow: auto;
      margin: 0.5rem 0;
      ::-webkit-scrollbar {
        height: 5px;
        display: none;
      }
      ::-webkit-scrollbar-thumb {
        border-radius: 2px;
      }
      .arrow {
        cursor: pointer;
        position: absolute;
        border-radius: var(--border-radius-9);
        background-color: var(--body-2);
        border: var(--border-style-2);
        padding:  0.5rem 0.1rem;
        top: calc(50% - 1rem);
        .icon {
            font-size: 2rem;
            display: block;
        }
        &.right {
            right:  calc(-12px);
        }
        &.left {
            left:  calc(-12px);
        }
      }

      .inside-scroll {
        /* width: 100%; */
        display: grid;
        padding: 0.5rem 1rem;
        grid-auto-columns: auto;
        gap: 1rem;
        .shop-cart{
          min-width: 250px;
          cursor: pointer;
          display: flex;
          gap: 0.5rem;
          padding: 1rem;
          background-color: #ffffff;
          border-radius: 4px;
          transition: all 0.25s ease-in-out;
          border: 1px solid var(--body-2);
          &.active {
            border: 1px solid var(--primary-10);
            box-shadow: 0px 0px 0px 4px #275A5933;
          }
          .image {
            width: 48px;
            height: 48px;
            border: 1px solid var(--gray-15);
            border-radius: 100px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .data1 {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            justify-content: center;
            .shop-name {
              font-size: 1rem;
              font-weight: 700;
            }
          }
          .data2 {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            justify-content: center;
            align-items: flex-end;
            .mindate {
              color: var(--gray-6);
              font-size: 12px;
              font-weight: 500;
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 0.2rem;
            }

            .price {
              font-size: 0.9rem;
              font-weight: 700;
              color: var(--gray-6);
            }
          }
        }
      }
      @media screen and (max-width :850px) {
        .arrow {
          display: none;
        }
      }
    }
  }
  .slideHorizontal___1NzNV,
  .horizontalSlider___281Ls {
      transform: scale(1) !important;
  }
  .carousel {
    * {
      overflow: visible;
      ul {
        padding: 0;
      }
    }
    overflow: hidden;
    width: 100%;
    margin: 0 auto;
    background-color: var(--gray-0);
    display: flex;
    flex-direction: column;
    position: relative;
    .sh-g-image {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }
  }
  .dot-carousel{
    direction: ltr;
    position: absolute;
    inset: auto 3rem 0.5rem;
    display: flex;
    justify-content: center;
    gap: 4px;
    overflow-x: auto;
    padding:0.2rem 0 ;
    ::-webkit-scrollbar{
        cursor: pointer;
        top: 5px;
        width: 3px;
        height: 3px;
      }
    .dots {
      direction: ltr;
      position: relative;
      max-width: 100%;
      display: flex;
      justify-content: flex-start;
      gap: 4px;      
      .dot {
          border: none;
          outline: none;
          border-radius: 4px;
          background-color: #fff;
          padding: 1.5rem;
          transition: all 0.2s ease-in-out;
          opacity: 1;
          position: relative;
          :disabled {
              opacity: 1;
              .overlay {
                opacity: 0;
              }
          }
          .dot-image {
            border-radius: 4px;
            box-shadow: 0px 4px 8px 0px #00000029 inset;
            width: 100%;
            height: 100%;
            display: block;
            object-fit: contain;
            position: absolute;
            inset: 0;
          }
          .overlay {
            transition: all 0.2s ease-in-out;
            position: absolute;
            inset: 0;
            background-color: #000;
            opacity: 0.2;
            border-radius: 4px;
          }
      }
      }
  }
  .ppp-main {
    display: flex;
    flex-direction: row;
    position: relative;
    padding: 0 var(--padding);
    width: calc(100% - var(--width-padding));
    gap: 20px;
    /* max-height:35rem; */
    .like , .share{
      position: absolute;
      top: 1rem;
      right: 1rem;
      padding: 0.5rem;
      height: 1.5rem;
      width: 1.5rem;
      aspect-ratio: 1;
      margin: auto;
      display: flex;
      align-items: center;
      border-radius: var(--border-radius-9);
      border: 2px solid rgba(255, 255, 255, 0.01);
      background: rgba(255, 255, 255, 0.40);
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.16);
      backdrop-filter: blur(15px);
      cursor: pointer;
      z-index: 1;
    }
    .share{
      right: 4rem;
    }
    .images{
      cursor: pointer;
      width: 50%;
      position: relative;
      border-radius: var(--border-radius-9);
      aspect-ratio:1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .backstand{
          position: absolute;
          inset: 0;
          box-shadow: var(--shadow-15);
          aspect-ratio: 1;
          border-radius: var(--border-radius-9);
          width: 100%;
      }
      .g-image{
          /* position: relative;
          margin: auto 28%  ;
          padding-top: 36%;
          width: 44%; */
          position: relative;
          display: block;
          aspect-ratio: 1;
          border-radius: var(--border-radius-9);
          color: var(--text-3);
          overflow: hidden;
          .shadow {
              position: absolute;
              width: 52.4%;
              height: 10%;
              display: block;
              left: calc(50% - calc(55% / 2));
              padding-top: calc(26.5% + 42%);
              margin: auto;
              object-fit: fill;
              transition: all 0.3s ease-in-out;
              transform-origin: bottom;
              opacity: 0.2;
              filter: brightness(0.2) blur(8px);
              transform-origin: bottom;
              transform: skewX(60deg);
              clip-path: ellipse(45% 4.7% at bottom);
          }
          .reflection{
              position: absolute;
              width: 52.4%;
              height: 20%;
              display: block;
              left: calc(50% - calc(52% / 2));
              padding-top: calc(26.5% + 32%);
              margin: auto;
              object-fit: fill;
              transition: all 0.3s ease-in-out;
              transform-origin: bottom;
              opacity: 0.4;
              filter: brightness(1.8) blur(2px);
              transform-origin: bottom;
              transform: scale(1, -1);
              clip-path: ellipse(59% 8.1% at bottom);
          }
          .main{
              position: relative;
              width: 52.4% ;
              display: block;
              padding-top: 28%;
              margin: auto;
              object-fit: contain;
              transition: all 0.3s ease-in-out;
              transform-origin: bottom;
          }
      }
      .garanrty-row{
        display: grid;
        grid-template-columns: repeat(4 , 25%);
        width: 100%;
        align-items: baseline;
        justify-content: space-between;
        margin-top: 2rem;
      }
    }
    .data {
      width: calc(50% - 4rem);
      aspect-ratio: 1;
      background-color: var(--body-2);
      border-radius: var(--border-radius-9);
      padding: 2rem;
      text-align: justify;
      .title {
          position: relative;
          font-size: var(--fs-good-page-name);
          font-weight: 850;
          width: 100%;
          padding-bottom: 0.5rem;
          border-bottom: var(--border-style-2);
          .english {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
              'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
              sans-seri;
            font-weight: 800;
            display: block;
          }
      }
      .details{
          display: flex;
          flex-direction: column;
          padding: 1.25rem 0;
          justify-content: flex-start;
          align-items: flex-start;
          text-align: right;
          border-bottom: var(--border-style-2);
          
          .lable{
              font-size: 0.87rem;
              font-weight: 500;
              color: var(--gray-6);
              margin-bottom: 0.5rem;
          }
          &.variety {
            flex-direction: row;
            align-items: center;
          }
          .g-variety {
            flex-grow: 1;
            display: flex;
            justify-content: flex-end;
            flex-wrap: wrap;
            gap: 0.5rem;
            .option {
              padding: 0.5rem;
              display: flex;
              gap: 0.25rem;
              border: 1px solid var(--gray-3);
              border-radius: 4px;
              font-size: 0.9rem;
              font-weight: 500;
              align-items: center;
              color: var(--gray-6);
              cursor: pointer;
              &.color-c {
                .color {
                  width: 20px;
                  height: 20px;
                  border-radius: 100px;
                }
              }
              &.active {
                border: 1px solid var(--primary-10);
                box-shadow: 0px 0px 0px 4px #275A5933;
              }
            }
          }
          .g-data{
              font-size: 1rem;
              color: var(--text-9);
              font-weight: 400;
              display: block; 
              line-height: 2rem;
              margin: 0;
              .features{
                line-height: 2rem;
                margin: 0;
                white-space: pre-line;
                font-size: 1rem;
                font-weight: 400;
              }
            }
        
          &.brand{
              flex-direction: row;
              justify-content: space-between;
              align-items:center ;
              .g-data {
                text-align: left;
                width: auto;
                .circle-logo{
                  border-radius: var(--border-radius-7);
                  width: 2rem;
                  height: 2rem;
                  position: relative;
                }
              }
          }
          &.send-to{
            font-weight: 700;
          }
          &.last , &.send-to{
            flex-direction: row;
            align-items: center;
            border-bottom: none;
            .price {
              width: 50%;
              font-size: 1.5rem;
              font-weight: 700;
              display: flex;
              flex-direction: row;
              gap: 0.3rem;
              .price-cut {
                display: flex;
                flex-direction: column;
                position: relative;
                &::after {
                  content: "15%";
                  /* width: 1.5rem; */
                  padding: 0.4rem 0.4rem 0.2rem;
                  font-size: 1rem;
                  background-color: #d32f2f;
                  color: #fff;
                  position: absolute;
                  top: 0;
                  right: -3.3rem;
                  z-index: 10;
                  border-radius: 100px;
                }
              }
              .price-num {
                display: flex;
                gap: 0.2rem;
                &.cut {
                    /* text-decoration: line-through; */
                    color: var(--gray-6);
                    position: relative;
                    isolation: isolate;
                    &::after {
                        content: " ";
                        width: calc(100% + 6px);
                        height: 4px;
                        background-color: #ff000088;
                        position: absolute;
                        top: calc(50% - 3px);
                        left: -3px;
                        z-index: 10;
                        border-radius: 100px;
                    }
                }
                
              }
            }
            .addtocart {
              width: 50%;
              font-size: 1.25rem;
              font-weight: 500;
              padding: 0.8rem 1rem;
              background-color: var(--primary-5);
              color: #fff;
              text-align: center;
              border-radius: 4px;
              cursor: pointer;
              &.disable {
                opacity: 0.7;
              }
              :hover {
                background-color: var(--primary-5h);
              }
            }
          }
          .view{
              color: #1677D9;
              font-weight: 500;
              font-size: 0.75rem;
              text-decoration: none;
              cursor: pointer;
          }
          :last-child{
            border-bottom: none;
          }
      }
    }
    @media screen and (max-width :850px) {
      flex-direction: column;
      max-height: initial;
      padding: 0 var(--padding);
      width: calc(100% - var(--width-padding));
      
      .images{
        width: 100%;
        padding: 0;
        border-radius: var(--border-radius-9);
        overflow: visible;
        .good-img{
            position: absolute;
            inset: 0;
            margin: auto 27% ;
            width: 45%;
            padding-top: 8%;
        }
        .backstand{
            position: absolute;
            width: 100%;
            border-radius: var(--border-radius-9);
          }
      }
      .data{
        position: relative;
        width: calc(100% - 2rem);
        padding: 1rem ;
        aspect-ratio: unset;
        .details{
          border-bottom: none;
          &.last {
            display: none;
          }
          &.variety{
            border-bottom: none;
          }
          &.send-to{
            border-top: 1px solid var(--gray-3); 
            align-items: baseline;
            text-align: center;
          }
          
        }
      }
      .garanrty-row{
        display: grid;
        grid-template-columns: repeat(2 , 50%);
        grid-row-gap: 1rem;
      }
    }
  }
  .add-to-basket-fix {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    text-align: right;
    border-bottom: var(--border-style-2);
    position: fixed;
    background-color: #fff;
    inset: auto 0 -120px 0;
    z-index: 100;
    padding: 1rem var(--padding);
    gap: 1rem;
    box-shadow: 0px -8px 24px 0px #00000029;
    transition: all 0.2s ease-in-out;
    
    &.active {
      inset: auto 0 0 0;
    }
    .image{
      width: 80px;
      position: relative;
      border-radius: var(--border-radius-9);
      aspect-ratio:1;
      overflow: hidden;
      .backstand{
          position: absolute;
          inset: 0;
          box-shadow: var(--shadow-15);
          aspect-ratio: 1;
          border-radius: var(--border-radius-9);
          width: 100%;
      }
      .g-image{
          /* position: relative;
          margin: auto 28%  ;
          padding-top: 36%;
          width: 44%; */
          position: relative;
          display: block;
          aspect-ratio: 1;
          border-radius: var(--border-radius-9);
          color: var(--text-3);
          overflow: hidden;
          .shadow {
              position: absolute;
              width: 52.4%;
              height: 10%;
              display: block;
              left: calc(50% - calc(55% / 2));
              padding-top: calc(26.5% + 42%);
              margin: auto;
              object-fit: fill;
              transition: all 0.3s ease-in-out;
              transform-origin: bottom;
              opacity: 0.2;
              filter: brightness(0.2) blur(8px);
              transform-origin: bottom;
              transform: skewX(60deg);
              clip-path: ellipse(45% 4.7% at bottom);
          }
          .reflection{
              position: absolute;
              width: 52.4%;
              height: 20%;
              display: block;
              left: calc(50% - calc(52% / 2));
              padding-top: calc(26.5% + 32%);
              margin: auto;
              object-fit: fill;
              transition: all 0.3s ease-in-out;
              transform-origin: bottom;
              opacity: 0.4;
              filter: brightness(1.8) blur(2px);
              transform-origin: bottom;
              transform: scale(1, -1);
              clip-path: ellipse(59% 8.1% at bottom);
          }
          .main{
              position: relative;
              width: 52.4% ;
              display: block;
              padding-top: 28%;
              margin: auto;
              object-fit: contain;
              transition: all 0.3s ease-in-out;
              transform-origin: bottom;
          }
      }
    }
    .information {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      gap: 0.5rem;
      .top {
        font-size: 1.25rem;
        font-weight: 500;
      }
      .btm {
        display: flex;
        color: var(--gray-6);
        gap: 0.3rem;
        .g-data {
          display: flex;
          gap: 0.3rem;
          align-items: center;
        }
        .vertical-line {
          width: 1px;
          background-color: #E5E5E5;
          margin: 0 0.5rem;
        }
        .color {
          width: 20px;
          height: 20px;
          border-radius: 100px;
        }
      }
    }
    .expand {
      flex-grow: 1;
    }
    .price {
      /* width: 50%; */
      font-size: 1.5rem;
      font-weight: 700;
      display: flex;
      flex-direction: row;
      gap: 0.3rem;
      .type {
        display: none;
      }
      .price-f {
        display: flex;
        gap: 0.3rem;
        .price-cut {
          display: flex;
          flex-direction: column;
          position: relative;
          &::after {
            content: "15%";
            /* width: 1.5rem; */
            padding: 0.4rem 0.4rem 0.2rem;
            font-size: 0.9rem;
            background-color: #d32f2f;
            color: #fff;
            position: absolute;
            top: 0;
            right: -3.3rem;
            z-index: 10;
            border-radius: 100px;
          }
        }
        .price-num {
          display: flex;
          gap: 0.2rem;
          &.cut {
              /* text-decoration: line-through; */
              color: var(--gray-6);
              position: relative;
              isolation: isolate;
              &::after {
                  content: " ";
                  width: calc(100% + 6px);
                  height: 2px;
                  background-color: #ff000088;
                  position: absolute;
                  top: calc(50% - 2px);
                  left: -3px;
                  z-index: 10;
                  border-radius: 100px;
              }
          }
        }
      }
    }
    .addtocart {
      width: 200px;
      font-size: 1.25rem;
      font-weight: 500;
      padding: 0.8rem 1rem;
      background-color: var(--primary-5);
      color: #fff;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
      &.disable {
        opacity: 0.7;
      }
      :hover {
        background-color: var(--primary-5h);
      }
    }
    @media screen and (max-width :850px) {
      flex-direction: column;
      inset: auto 0 0 0;
      padding: 0.5rem var(--padding) 1rem;
      .image {
        display: none;
      }
      .information {
        display: none;
      }
      .price {
        width: calc(100%);
        justify-content: space-between;
        align-items: center;
        font-size: 1rem;
        .type {
          display: flex;
          color: var(--gray-6);
          font-size: 1rem;
          font-weight: 500;
        }
      }
      .addtocart {
        width: calc(100% - 2rem);
      }
    }
  }
`;

class GoodHeader2 extends React.Component {
  constructor(props) {
    super(props);
    this.shareRef = createRef();
    this.shopContainer = createRef()
    this.state={
      like: props.favorite,
      shopselected: {},
      selectedColor: "",
      navActive: false,
      open: false,
      selectedImg: 0,
    }
  }
  componentDidMount() {
    this._ismounted = true;
    if(this.props.listshops.length !== 0){
      let srch = (new URLSearchParams(this.props.location.search)).get("shop")
      if(srch){
        let imp =[]
        this.props.listshops.forEach(element => {
          if(element.SH_CODE === parseInt(srch)){
            imp.push(element)
          }
        });
        if(imp.length > 0){
          this.setState({
            shopselected: imp[0]
          })
          let goods = imp[0].goods;
          if(goods.length){
            this.setState({
              selectedColor:goods[0].SH_G_CODE
            })
          }
        }
      }else{
        this.setState({
          shopselected: this.props.listshops[0]
        })
        let goods = this.props.listshops[0].goods;
        if(goods.length){
          this.setState({
            selectedColor: goods[0].SH_G_CODE
          })
        }
      }
    }
  }
  componentWillUnmount(){
    this._ismounted = false;
    document.removeEventListener('scroll', this.TopActiveGood);
  }
  setOpen = (e) => {
    this.setSelectedImg(0);
    // if(window.innerWidth < 850){
    //   return;
    // }
    this.setState({
        open: e
    })
  }
  setSelectedImg = (e) => {
    this.setState({
      selectedImg: e
    })
  }
  TopActiveGood = (e) => {
    if (window.scrollY > (window.innerHeight - 100)) {
      if(this.state.navActive === false){
        this.setState({
          navActive: true,
        });
      }
    } else {
      this.setState({
        navActive: false,
      });
    }
  };
  shareHandel = () => {
    if(typeof window.navigator.share === "function" ){
      window.navigator.share({
        title: "share with friend",
        text: "send good link",
        url: encodeURI("https://Luxinlux.com/good/"+this.props.all.G_CODE+'/'+this.props.all.G_URL+'/'),
      });
    }
  };
  makeItShort = (text , count) => {
    if(text.length > count){
        return text.slice(0,count) + '...';
    } else {
        return text
    }
  }
  setFav=(G_CODE,SH_CODE)=>{
    if(localStorage.getItem("token")){
      let formData = new FormData();
      formData.append("api_token", localStorage.getItem("token"));
      formData.append("U_CODE",  JSON.parse(localStorage.getItem('userdata')).usercode);
      formData.append("G_CODE", G_CODE);
      formData.append("SH_CODE", SH_CODE ?? -1);
      PostData(
          process.env.REACT_APP_API + "/api/v1/goods/user_views/favorite_update",
          formData,
          this,
          this.processLike
      );
    }else{
      insertError('برای افزودن به علاقه‌مندی‌ها لازم است وارد حساب کاربری شوید' , 'red', 6000 )
    }
  }
  processLike=(obj, response)=>{
    response = JSON.parse(response);
    if (response.status === "success") {
      this.setState({
        like : response.data.is_favorite
      })
    } else if (response.status === "error") {
      insertError(response.message, "red", 5000)
    } else if (response.status === "error-no-internet") {
      insertError(response.message, "red", 5000)
    }
  }
  selectShop = (SH_CODE) => {
    let find = this.props.listshops.find((v) => v.SH_CODE === SH_CODE);
    this.setState({
      shopselected: find
    })
    let goods = find.goods;
    if(goods.length){
      this.setState({
        selectedColor: goods[0].SH_G_CODE
      })
    }
  }
  getMinPrice = (shop) => {
    let min = "";
    for (let i = 0; i < shop.goods.length; i++) {
      const good = shop.goods[i];
      if(i === 0){
        min = good.SH_G_PRICE
      }
      if(min > good.SH_G_PRICE){
        min = good.SH_G_PRICE
      }
    }
    return formatPrice(min)
  }
  getMinDate = (shop) => {
    let min = "";
    for (let i = 0; i < shop.goods.length; i++) {
      const good = shop.goods[i];
      if(i === 0){
        min = good.SH_G_REQ_DAY
      }
      if(min > good.SH_G_REQ_DAY){
        min = good.SH_G_REQ_DAY
      }
    }
    return  " " + min + " "
  }
  makeshops = () => {
    if(this.props.listshops.length === 0){
      return ""
    }
    let shops = this.props.listshops;
    let shopshtml = [];
    for (let i = 0; i < shops.length; i++) {
      const shop = shops[i];
      let minProce = this.getMinPrice(shop);
      let minDate = this.getMinDate(shop);
      let active = false;
      if(this.state.shopselected.SH_CODE === shop.SH_CODE){
        active = true
      }
      shopshtml.push(
        <div className={"shop-cart " + (active ? "active" : "")} onClick={() => this.selectShop(shop.SH_CODE)}>
          <div className="image">
            <img src={shop.SH_LOGO} alt={shop.SH_NAME}/>
          </div>
          <div className="data1">
            <div className="shop-name">{shop.SH_NAME}</div>
          </div>
          <div className="data2">
            <div className="mindate">
              <img src={truck} alt="truck"/>
              {minDate}
              روزکاری
            </div>
            <div className="price">
              {minProce} تومان
            </div>
          </div>
        </div>
      )
    }

    let num = shopshtml.length;
    // let num = 4;
    let width = "calc(calc(100% - 2rem))";
    let columns = "";
    for (let i = 0; i < num; i++) {
      columns+= " auto";  
    }
    if(num > 3){
      width = "calc(calc(calc(100% - 2rem)) / 3) * "+num+")"
    }
    let arrows = ""
    if(num > 3){
      arrows = (
        <>
          <div 
            className="arrow left"
            onClick={() => {
              this.shopContainer.current.scrollTo({
                left: this.shopContainer.current.scrollLeft - this.shopContainer.current.clientWidth,
                behavior: 'smooth',
              })
            }}
          >
            <ChevronLeft className="icon"/>
          </div>
          <div 
            className="arrow right"
            onClick={() => {
              this.shopContainer.current.scrollTo({
                left: this.shopContainer.current.scrollLeft + this.shopContainer.current.clientWidth,
                behavior: 'smooth',
              })
            }}
          >
            <ChevronRight className="icon"/>
          </div>
        </>
      )
    }

    return (
      <div className="shoptop-container">
        <div className="title">
          فروشگاه ها
        </div>
        <div className="scroll-container" ref={this.shopContainer}>
          <div className="inside-scroll" 
            style={{gridTemplateColumns: columns, width: width+""}}
          >
            {shopshtml}
          </div>
          {arrows}
        </div>
      </div>
    )
  }
  shopCount=()=>{
    let select = this.state.shopselected
    if(Object.keys(select).length !== 0){
      if(select.goods){
        let find = select.goods.find(v => v.SH_G_CODE === this.state.selectedColor)
        if(find.SH_G_SALABLE_COUNT > 2){
          return(
            <div className="details  send-to"> موجود در انبار</div>
          )
        }else if(0 < find.SH_G_SALABLE_COUNT && find.SH_G_SALABLE_COUNT <= 2){
          return(
            <div className="details send-to"> تنها <span style={{textDecoration:'underline' ,margin:'0 0.5rem'}}> {find.SH_G_SALABLE_COUNT } </span> عدد در انبار باقی مانده. </div>
          )
        }else{
          return
        }
      }
    }
    return
  }
  makeColors = () => {
    if(Object.keys(this.state.shopselected).length === 0){
      return "";
    }
    let options = [];
    let packnames = [];
    let findpack;
    for (let i = 0; i < this.state.shopselected.goods.length; i++) {
      const good = this.state.shopselected.goods[i];
      switch(good.G_PACK_CODE) {
        case 1:
          options.push(
            <div 
              className={"option color-c " + ((good.SH_G_CODE === this.state.selectedColor) ? "active" : "")}
              onClick={() => {
                this.setState({
                  selectedColor: good.SH_G_CODE
                })
              }}
            >
              <div className="color" style={{backgroundColor: good.G_COL_IMG}}>
              </div>
              <div className="name">{good.G_COL_NAME}</div>
            </div>
          )
          findpack = packnames.findIndex((v) => v.Code === good.G_PACK_CODE);
          if(findpack !== -1){
            packnames[findpack].num++
          } else {
            packnames.push({
              Code: good.G_PACK_CODE,
              name: good.G_PACK_NAME,
              num: 1,
            })
          }
          break;
        default:
          options.push(
            <div 
              className={"option color-c " + ((good.SH_G_CODE === this.state.selectedColor) ? "active" : "")}
              onClick={() => {
                this.setState({
                  selectedColor: good.SH_G_CODE
                })
              }}
            >
              <div className="name">{good.G_COL_NAME}</div>
            </div>
          )
          findpack = packnames.findIndex((v) => v.Code === good.G_PACK_CODE);
          if(findpack !== -1){
            packnames[findpack].num++
          } else {
            packnames.push({
              Code: good.G_PACK_CODE,
              name: good.G_PACK_NAME,
              num: 1,
            })
          }
          break;
      }
    }
    let selectedPack = ""
    let num = 0
    for (let i = 0; i < packnames.length; i++) {
      const pack = packnames[i];
      if(num < pack.num){
        selectedPack = pack.name;
        num = pack.num
      }
    }
    return (
      <div className="details variety">
        <label className="lable">{selectedPack}: </label>
        <div className="g-variety">{options}</div>
      </div>
    )
  }
  makePriceAndCart = () => {
    let good=this.props.all
    let nogood = (
      <>
      <div className="details last">
        <div className="price"></div>
        <div className="addtocart disable">ناموجود</div>
      </div>
      <div className={"add-to-basket-fix" + ((this.state.navActive) ? " active" : "")}>
        <div className="image">
          <img src={goodStand} alt='goodStand' className="backstand"/>
          <div className="g-image">
              <img className="shadow" src={good.G_IMAGE} alt={good.G_NAME}/>
              <img className="reflection" src={good.G_IMAGE} alt={good.G_NAME}/>
              <img className="main" src={good.G_IMAGE} alt={good.G_NAME}/>
          </div>
        </div>
        <div className={"information"}>
          <div className="top">
            {good.G_NAME}
          </div>
          <div className="btm">
              <label className="lable">برند محصول : </label>
              <div className="g-data">
                  {good.G_BR_IMG ? <img alt={good.G_BR_NAME} src={good.G_BR_IMG} className="circle-logo"/> :''}
                  {good.G_BR_NAME}
              </div>
          </div>
        </div>
        <div className="expand"></div>
        <div className="price">
          <div className="type">
            قیمت: 
          </div>
          <div className="price-f">
            {/* <div className="price-num">-</div> تومان */}
          </div>
        </div>
        <div className="addtocart disable">ناموجود</div>
      </div>
      </>
    )
    if(Object.keys(this.state.shopselected).length === 0){
      return nogood
    }
    let find = this.state.shopselected.goods.find((v) => v.SH_G_CODE === this.state.selectedColor);
    if(!find){
      return nogood;
    }
    let selected = this.state.shopselected.goods.find(v => v.SH_G_CODE === this.state.selectedColor)
    return(
      <>
        <div className="details last">
          <div className="price">
              {
                (checkPriceCut(find.SH_CODE, find.G_CODE)) ? (
                  <div className="price-cut">
                    <div className="price-num curency cut"><span>{formatPrice(Math.floor(changePrice(find.SH_G_PRICE)))}</span>تومان</div> 
                    <div className="price-num curency"><span>{formatPrice(find.SH_G_PRICE)}</span>تومان</div> 
                  </div>
                ) : (
                  <>
                    <div className="price-num curency"><span>{formatPrice(find.SH_G_PRICE)}</span></div> تومان
                  </>
                )
              }
            {/* <div className="price-num curency"><span>{formatPrice(find.SH_G_PRICE)}</span></div> تومان */}
          </div>
          {
            (selected.SH_G_CONTROL && (selected.SH_G_SALABLE_COUNT !== 0)) ? (
              <div className="addtocart" onClick={() => {
                insertGood(find)
              }}>افزودن به سبد خرید</div>
            ) : (
              <div className="addtocart disable" onClick={() => {
              }}>ناموجود</div>
            )
          }
        </div>
        <div className={"add-to-basket-fix" + ((this.state.navActive) ? " active" : "")}>
          <div className="image">
            <img src={goodStand} alt='goodStand' className="backstand"/>
            <div className="g-image">
                <img className="shadow" src={good.G_IMAGE} alt={good.G_NAME}/>
                <img className="reflection" src={good.G_IMAGE} alt={good.G_NAME}/>
                <img className="main" src={good.G_IMAGE} alt={good.G_NAME}/>
            </div>
          </div>
          <div className={"information"}>
            <div className="top">
              {good.G_NAME}
            </div>
            <div className="btm">
                <label className="lable">برند محصول : </label>
                <div className="g-data">
                    {good.G_BR_IMG ? <img alt={good.G_BR_NAME} src={good.G_BR_IMG} className="circle-logo"/> :''}
                    {good.G_BR_NAME}
                </div>
                <div className="vertical-line"></div>
                <label className="lable">{selected.G_PACK_NAME} : </label>
                <div className="g-data">
                    {
                      (selected.G_PACK_CODE === 1) ? (
                        <div className="color" style={{backgroundColor: selected.G_COL_IMG}}></div>
                      ) : ""
                    }
                    {selected.G_COL_NAME}
                </div>
            </div>
          </div>
          <div className="expand"></div>
          <div className="price">
            <div className="type">
              قیمت: 
            </div>
            <div className="price-f">
              {
                (checkPriceCut(find.SH_CODE, find.G_CODE)) ? (
                  <div className="price-cut">
                    <div className="price-num curency cut"><span>{formatPrice(Math.floor(changePrice(find.SH_G_PRICE)))}</span>تومان</div> 
                    <div className="price-num curency"><span>{formatPrice(find.SH_G_PRICE)}</span>تومان</div> 
                  </div>
                ) : (
                  <>
                    <div className="price-num curency"><span>{formatPrice(find.SH_G_PRICE)}</span></div> تومان
                  </>
                )
              }
            </div>
          </div>
          {
            (selected.SH_G_CONTROL && (selected.SH_G_SALABLE_COUNT !== 0)) ? (
              <div className="addtocart" onClick={() => {
                insertGood(find)
              }}>افزودن به سبد خرید</div>
            ) : (
              <div className="addtocart disable" onClick={() => {
              }}>ناموجود</div>
            )
          }
        </div>
      </>
    )
  }
  makeImageSlides = (images = []) => {
    let good=this.props.all
    return images.map((v, i) => {
      if(i === 0){
        return (
          <Slide
            key={i} 
            index={images.length - (i+1)} 
            classNameVisible="slider-good-visible"
          >
            <img src={goodStand} alt='goodStand' className="backstand"/>
            <div className="g-image header-image-enter-done">
                <img className="shadow" src={v} alt={good.G_NAME}/>
                <img className="reflection" src={v} alt={good.G_NAME}/>
                <img className="main" src={v} alt={good.G_NAME}/>
            </div> 
          </Slide>
        )
      }
      return (
        <Slide
          key={i} 
          index={images.length - (i+1)} 
          classNameVisible="slider-good-visible"
        >
          <img className="sh-g-image" src={v.G_IMG_ADDRESS} alt={good.G_NAME}/>
        </Slide>
      )
    })
  }
  getImagesList = () => {
    let good=this.props.all
    if(this.props.listshops.length === 0){
      return [good.G_IMAGE]
    }
    let images = [good.G_IMAGE];
    let shopgoods = this.state.shopselected.goods;
    if(!this.state.shopselected.goods){
      return [good.G_IMAGE]
    }
    for (let i = 0; i < shopgoods.length; i++) {
      const shopgood = shopgoods[i];
      if(shopgood.SHOP_GOODS_IMAGE && shopgood.SHOP_GOODS_IMAGE.length){
        images.push(...shopgood.SHOP_GOODS_IMAGE)
      }
    }
    return images
  }

  garantyField =()=>{
    return(<Garanty classname={'garanrty-row'}/> )
  }
  renderS() {
    document.addEventListener('scroll', this.TopActiveGood);
    let good=this.props.all
    let textFields =this.makeItShort(good.G_SHORT_DESC , 170)
    let featuresFields = ( good.G_FEATURES  ? this.makeItShort(good.G_FEATURES ,300) : '' );
    let images = this.getImagesList();
    let name = (
      <>
        {good.G_NAME} / <span className="english">{good.G_LATIN_NAME}</span>
      </>
    );
    // let name = good.G_NAME
    // if(good.G_TAG_CODE === 6){
    //   name = (
    //     <>
    //       {good.G_NAME} - <span className="english">{good.G_LATIN_NAME}</span>
    //     </>
    //   )
    // }    
    return (
      <React.Fragment>
        <Styles>
            {this.makeshops()}
            <div className="ppp-main">
              <div className="images">
                <CarouselProvider
                  naturalSlideWidth={100}
                  naturalSlideHeight={100}
                  totalSlides={images.length}
                  playDirection="backward"
                  currentSlide={0}
                  visibleSlides={1}
                  onClick={() => this.setOpen(true)}
                  // isPlaying={(window.innerWidth < 850) ? true}
                  // interval={6000}
                > 
                  <Slider>
                    {this.makeImageSlides(images)}
                  </Slider>
                  <div className="dot-carousel">
                    <div className="dots">
                      {
                        images.map((v, i) => {
                          if(i === 0){
                            return (
                              <Dot
                                  className="dot"
                                  key={i}
                                  slide={i}
                              >
                                <img className="dot-image" src={v} alt={good.G_NAME}/>
                                <div className="overlay"></div>
                              </Dot>
                            )
                          }
                          return (
                              <Dot
                                  className="dot"
                                  key={i}
                                  slide={(i)}
                              >
                                <img className="dot-image" src={v.G_IMG_ADDRESS} alt={good.G_NAME}/>
                                <div className="overlay"></div>
                              </Dot>
                          )
                        })
                      }
                    </div>

                  </div>
                </CarouselProvider>
                  {/* <img src={goodStand} alt='goodStand' className="backstand"/>
                  
                  <div className="g-image">
                      <img className="shadow" src={good.G_IMAGE} alt={good.G_NAME}/>
                      <img className="reflection" src={good.G_IMAGE} alt={good.G_NAME}/>
                      <img className="main" src={good.G_IMAGE} alt={good.G_NAME}/>
                  </div> */}

                  {/* <img src={good.G_IMAGE} alt={good.G_NAME} className="good-img"/> */}

                  <div className="like " onClick={()=>this.setFav(good.G_CODE , good.SH_CODE)}>
                    {
                      this.state.like === 1 ?
                        <Like classname='like-red'/>
                      :
                        <img src={dLike} alt='Like' classname='like-gray'/>
                    }
                  </div>
                  <div className="share" onClick={()=>this.shareHandel()} >
                      <Share />
                  </div>
                 {window.innerWidth > 850  ? this.garantyField() :''}
              </div>
              <div className="data">
                <h1 className="title">{name}</h1>
                <div className="details">
                    <label className="lable">توضیحات : </label>
                    <div className="g-data">{textFields}</div>
                    <div className="view" onClick={this.props.scrollDesc}>توضیحات کامل »</div>
                </div>
                <div className="details brand">
                    <label className="lable">برند محصول : </label>
                    <div className="g-data">
                        {good.G_BR_IMG ? <img alt={good.G_BR_NAME} src={good.G_BR_IMG} className="circle-logo"/> :''}
                        {good.G_BR_NAME}
                    </div>
                </div>
                {this.makeColors()}
                {
                  good.G_FEATURES ?
                  (
                    <div className="details">
                        <label className="lable">ویژگی ها : </label>
                        <div className="g-data ">
                            <pre className="features">
                              {featuresFields}
                            </pre>
                        </div>
                    </div>
                  )
                  :''
                }
                {this.shopCount()}
                {this.makePriceAndCart()}
              </div>
              {window.innerWidth < 850  ? this.garantyField() :''}
            </div>
        </Styles>
        <GoodPicManager 
          title={name}
          open={this.state.open} 
          setOpen={this.setOpen} 
          selectedImg={this.state.selectedImg} 
          setSelectedImg={this.setSelectedImg} 
          good={good} 
          shops={this.props.listshops}/>
      </React.Fragment>
    );
  }
  render(){
    return this.renderS();
  }

}

export default GoodHeader2;
